import React from 'react';
import { Switch } from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute';

import {
  HubListDriver,
  HubCreateDriver,
  HubUpdateDriver,
} from 'pages/Hub/Driver';
import {
  HubListVehicle,
  HubCreateVehicle,
  HubUpdateVehicle,
} from 'pages/Hub/Vehicle';

interface Props {}

export const HubRoutes: React.FC<Props> = () => {
  return (
    <Switch>
      {/* Motorista */}
      <PrivateRoute
        exact
        path="/settings/hub-drivers"
        component={HubListDriver}
        hasPermission="accessDriverHUB"
      />
      <PrivateRoute
        exact
        path="/settings/hub-drivers/new"
        component={HubCreateDriver}
        hasPermission="accessDriverHUB"
      />
      <PrivateRoute
        exact
        path="/settings/hub-drivers/edit/:id"
        component={HubUpdateDriver}
        hasPermission="accessDriverHUB"
      />
      {/* Veiculos */}

      <PrivateRoute
        exact
        path="/settings/hub-vehicles"
        component={HubListVehicle}
        hasPermission="accessVehicleHUB"
      />
      <PrivateRoute
        exact
        path="/settings/hub-vehicles/new"
        component={HubCreateVehicle}
        hasPermission="accessVehicleHUB"
      />
      <PrivateRoute
        exact
        path="/settings/hub-vehicles/edit/:id"
        component={HubUpdateVehicle}
        hasPermission="accessVehicleHUB"
      />
    </Switch>
  );
};
